import { truncateNameWithDot, uppercaseFirstCharInText} from '@sky-it-livedata-libraries/livedata-commons';
import { DriversRankingQuery } from "../types";
import { isValidDriversRanking } from "./typeguards";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { IDriverStandings, ITopDriversTable } from "@sky-it-livedata/livedata-sports-design-system";
import { intcmpMap } from '../../../utils/intcmp';

import { DRIVERS_STANDING_TOTAL_POINTS } from "../../../types/drivers-standings";

import {IDriverInfoTotalPoints} from "../../../types/driver"
import  { IDriverSessionDetail } from "../../../types/session"
import { IStandingRows } from '../../../types/standing';
import { IDriversTotalPointStandingRow } from "../../../types/drivers-standings";

import {
  DriverRankingWidget,
  DriverRankingDriver,
  CreateDriverRankingWidgetInputSchema,
  DriverRankingDriverInfo,
} from "appsync";



export const FALLBACK_LABEL = '-';

export const getTeamNameDriverInfoTotalPoints = (row: IDriverInfoTotalPoints): string =>
  row.customTeamName || FALLBACK_LABEL;

export const getDriverName = (row: IDriverInfoTotalPoints | IDriverSessionDetail): string =>
  row.customDriverName && row.customDriverSurname
    ? `${row.customDriverSurname} ${truncateNameWithDot(row.customDriverName)}`
    : `${uppercaseFirstCharInText(row.lastName)} ${truncateNameWithDot(row.firstName.toUpperCase())}`;

export const transformRow = (row: DriverRankingDriverInfo): IDriversTotalPointStandingRow => {
  const {
    pos: position,
    pts: points,
    flagUrl: logoUrl,
    customDriverPageUrl: driverUrl,
    customTeamPageUrl: teamUrl,
  } = row;

  return {
    position: position as string,
    points: points as string,
    logoUrl: logoUrl as string,
    driverUrl: driverUrl as string,
    teamUrl: teamUrl as string,
    driverName: getDriverName(row as IDriverInfoTotalPoints) as string,
    teamName: getTeamNameDriverInfoTotalPoints(row as IDriverInfoTotalPoints) as string,
  };
};

export const transformRows = (rowsData: DriverRankingWidget): IStandingRows<IDriversTotalPointStandingRow> => {

  const items = rowsData!.items as DriverRankingDriver[]

  const rows: ReadonlyArray<IDriversTotalPointStandingRow> = items.map((item: DriverRankingDriver) => {
    if (item?.driverInfo) {
      return transformRow(item.driverInfo)
    } else {
      throw new WidgetError<ErrorName>({
        name: "NO_VALID_DATA",
        message: "Invalid transformer input, Error in DriverRankingDriver object - missing driverInfo",
        data: item,
      });
    }
  });

  return {
    rankingVariant: DRIVERS_STANDING_TOTAL_POINTS,
    rows: rows as IDriversTotalPointStandingRow[],
    trackingData: intcmpMap.driversRanking,
  };
};

export const transformStandingsList = (
  obj: DriversRankingQuery
): ReadonlyArray<IStandingRows<IDriversTotalPointStandingRow>> => {
  return [transformRows(obj.data.getDriverRankingWidget)];
};


export default (obj: DriversRankingQuery): IDriverStandings => {
  if (isValidDriversRanking(obj)) {
    const driverRankingWidget = obj.data.getDriverRankingWidget;

    CreateDriverRankingWidgetInputSchema().parse(driverRankingWidget, { reportInput: true });

    
    return {
      competitionName: driverRankingWidget.competitionLabel!,
      rankingVariant: DRIVERS_STANDING_TOTAL_POINTS,
      standingsList: transformStandingsList(obj) as ITopDriversTable[],
    }
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in DriversRankingQuery object",
      data: obj,
    });
  }
};
